import { MutationHookOptions, useMutation } from '@apollo/client';

import { UPDATE_PARENT } from './mutations';

export const useUpdateParent = (options?: MutationHookOptions) => useMutation(UPDATE_PARENT, options);
